<template>
  <div>
    <div class="row t-row">
      <div class="col-md-8">
        <carousel
          :margin="10"
          :nav="true"
          :nav-text="['', '']"
          :dots="false"
          :items="1"
          :key="new Date().toString()"
        >
          <lich-tot-xau
            v-for="(item, index) in data"
            :key="index"
            :data="item"
          />
        </carousel>
      </div>
      <div class="col-md-4">
        <form-input
        @submit="getData"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import carousel from 'vue-owl-carousel'
import { getLich } from '../utils/trachnhat/trachnhat'
import LichTotXau from '../components/trachnhat/LichTotXau'
import FormInput from '../components/trachnhat/FormInput'

export default {
  name: 'TrachNhat',
  components: {
    carousel,
    LichTotXau,
    FormInput
  },
  data () {
    return {
      type: 1,
      data: {}
    }
  },
  created () {
    this.getData({ dates: [moment().format('YYYY-MM-DD')] })
  },
  computed: {
    isCarousel () {
      return this.type !== 1
    }
  },
  methods: {
    getData ({ dates, type }) {
      this.type = type
      this.data = getLich(dates)
    }
  }
}
</script>

<style scoped src="../assets/css/bootstrap2.min.css"/>
<!--<style scoped src="../assets/css/lichTotXau.css"/>-->
<style scoped>

</style>
